<template>
  <p class="info-text">
    {{ labelText }}:{{ '\u00A0' }}

    <router-link
      v-if="isRouterLink"
      class="form__link"
      target="_blank"
      :to="{ name: route.name, params: route.params }"
    >
      {{ getText }}
    </router-link>

    <a v-else-if="isLink" class="form__link" :href="href">
      {{ getText }}
    </a>

    <span v-else>
      {{ getText }}
    </span>
  </p>

</template>

<script>
import { MIXIN_INFO_TEXT } from '@/mixins/components/mixinInfoText'
import { getYesOrNo } from '@/utils/string/getYesOrNo'

export default {
  mixins: [MIXIN_INFO_TEXT],
  computed: {
    getText () {
      if (typeof this.text === 'boolean') {
        return getYesOrNo(this.text)
      }
      return this.text
    }
  }
}
</script>

<style lang="scss">
.info-text {
  display: flex;
  color: $font_color_second;

  span {
    color: $font_color_third;
  }
}
</style>
